// Container imports
const {
  TOOLTIP_ADD,
  TOOLTIP_DISMISS,
  TOOLTIP_REMOVE
} = require('./actions')
const TooltipItemRecord = require('./records/item')
const TooltipsRecord = require('./record')

function tooltipsReducer(state = new TooltipsRecord(), action) {
  const { type, payload } = action
  switch (type) {
    case TOOLTIP_ADD:
      return (state || new TooltipsRecord).addItem(new TooltipItemRecord(payload))
    case TOOLTIP_DISMISS:
      return state && state.dismissItem(payload.key)
    case TOOLTIP_REMOVE:
      return state && state.removeItem(payload.key)
    default:
      return state
  }
}

module.exports = tooltipsReducer
